import { logger } from '@/checkout-instore-legacy/Logger'
import { ItemPayload } from '@/checkout-instore-legacy/cart/message/types'

type LoggableItem = Item | ItemPayload | Partial<ItemPayload>

function logProductItemAction(item: LoggableItem, action: string) {
  logger.debug({
    message: 'logProductItemAction cart product item called',
    workflowType: 'cart-product-item-action',
    data: {
      action,
      item,
    },
  })
}

export function logClick(item: Item) {
  logProductItemAction(item, 'click-on-item')
}

export function logChangeSla(item: Item) {
  logProductItemAction(item, 'change-item-sla')
}

export function logRemove(itemPayload: ItemPayload) {
  logProductItemAction(itemPayload, 'remove-item')
}

export function logChangeQuantity(itemPayload: ItemPayload) {
  logProductItemAction(itemPayload, 'change-quantity')
}

export function logClearItemError(partialItemPayload: Partial<ItemPayload>) {
  logProductItemAction(partialItemPayload, 'clear-error')
}
